export const regexForSuv = /^([1-6])/;
export const regexForOtherCarTypes = /^([1-4])/;
export const mobileRegex = /^\d{10}$/;
export const nameRegex = /^[a-zA-Z ]/;
